/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { SelfHelpRoutingModule } from './selfhelp-routing.module';
import { SelfHelpComponent } from './components/selfhelp.component';
import { KnowledgeBaseComponent } from './components/knowledgebase.component';
import { KbaService } from './services/kba.service';
import { KnowledgeBaseFilterComponent } from './components/knowledgebasefilter.component';
import { KnowledgeBaseFilterService } from './services/knowledgebasefilter.service';
import { SharedModule } from '../../../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { ReactiveFormsModule } from '@angular/forms';
import { KnowledgeBaseContainerComponent } from './knowledgebasecontainer/knowledgebasecontainer.component';
import { KnowledgeBaseDetailComponent } from './knowledgebasecontainer/knowledgebasedetail/knowledgebasedetail.component';
import { RelatedKnowledgeBaseComponent } from './knowledgebasecontainer/relatedknowledgebase/relatedknowledgebase.component';
import { KnowledgeBaseDetailService } from './knowledgebasecontainer/knowledgebasedetail/knowledgebasedetail.service';
import { RelatedKnowledgeBaseService } from './knowledgebasecontainer/relatedknowledgebase/relatedknowledgebase.service';
import { EllipsisModule } from 'ngx-ellipsis';
import { InfiniteScrollModule } from '../shared/module/infinite-scroll.module';
import { KbacommentsComponent } from './knowledgebasecontainer/knowledgebasedetail/kbacomments/kbacomments.component';
import { KbacommentsService } from './services/kbacomments.service';

 @NgModule({
  imports: [
    SharedModule,
    SelfHelpRoutingModule,
    SpinnerModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    DataTablesModule,
    EllipsisModule
   ],
  declarations: [
    SelfHelpComponent,
    KnowledgeBaseComponent,
    KnowledgeBaseFilterComponent,
    KnowledgeBaseContainerComponent,
    KnowledgeBaseDetailComponent,
    RelatedKnowledgeBaseComponent,
    KbacommentsComponent
  ],
  providers: [
    KbaService,
    KnowledgeBaseFilterService,
    KnowledgeBaseDetailService,
    RelatedKnowledgeBaseService,
    KbacommentsService
  ],
  exports: [
    SelfHelpComponent
  ]
})
export class SelfHelpModule { }
